import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface LoginHeaderProps {
  logoSrc: string;
}

export const LoginHeader: React.FC<LoginHeaderProps> = ({ logoSrc }) => {
  return (
    <Box
      component="header"
      sx={{
        width: '100%',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
      }}
    >
      <Box
        sx={{
          mx: 'auto',
          px: 3,
          py: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          component="img"
          src={logoSrc}
          alt="OptumRx Logo"
          sx={{ height: 36, width: 'auto' }}
        />
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: '#3D3C38',
          }}
        >
          Advanced Claim View
        </Typography>
      </Box>
    </Box>
  );
};

export default LoginHeader;